/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Subject } from "rxjs/Subject";
import { Injectable } from "@angular/core";
var ButtonInGroupService = (function () {
    function ButtonInGroupService() {
        this._changes = new Subject();
    }
    Object.defineProperty(ButtonInGroupService.prototype, "changes", {
        get: function () {
            return this._changes.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ButtonInGroupService.prototype.updateButtonGroup = function (button) {
        this._changes.next(button);
    };
    return ButtonInGroupService;
}());
export { ButtonInGroupService };
ButtonInGroupService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ButtonInGroupService.ctorParameters = function () { return []; };
//# sourceMappingURL=buttonInGroup.service.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/button/providers/buttonInGroup.service.js
// module id = 146
// module chunks = 4